<template>
  <div class="navigation-drawer">
    <v-toolbar flat height="64px">
      <router-link to="/">
        <img src="/static/img/logo.png" alt="" id="logo" />
      </router-link>
    </v-toolbar>
    <v-divider></v-divider>
    <v-list dense id="navbarList" class="pt-0">
      <v-list-tile v-if="homeVisible" :to="{ name: 'Dashboard' }" class="optionNavbarWithoutChildren" v-model="homeactive" v-on:click="subToggle(0)">
        <v-list-tile-action>
          <v-icon>mdi-home</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="dps-nav-title">{{ $t('private_menu_home') }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>

      <template v-for="parking in parkings">
        <v-list-group
          prepend-icon="mdi-parking"
          :key="parking.id"
          append-icon=""
          active-class="primary--text"
          v-model="parking.misc.menu.group"
          :class="`border-${parking.misc.statusColor} dps-nav-title`"
          v-if="parking.fullControl"
        >
          <v-list-tile slot="activator" :to="{ name: 'ParkingHome', params: { id: parking.id } }">
            <v-list-tile-content>
              <v-list-tile-title>{{ parking.name }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{ name: 'ParkingHome', params: { id: parking.id } }" v-model="parking.misc.menu.stats">
            <v-list-tile-action>
              <v-icon>mdi-poll</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('private_menu_parkings_stats') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{ name: 'ParkingInformation', params: { id: parking.id } }" v-model="parking.misc.menu.info">
            <v-list-tile-action>
              <v-icon>mdi-tune</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('private_menu_parkings_file') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <template v-if="showInvoices">
            <v-list-tile :to="{ name: 'ParkingInvoices', params: { id: parking.id } }" v-model="parking.misc.menu.invoice">
              <v-list-tile-action>
                <v-icon>mdi-cash-multiple</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>{{ $t('private_menu_parkings_invoices') }}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
          </template>

          <v-list-tile :to="{ name: 'ParkingReports', params: { id: parking.id } }" v-model="parking.misc.menu.reports">
            <v-list-tile-action>
              <v-icon>mdi-file-chart</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('private_menu_parkings_reports') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{ name: 'ParkingActivity', params: { id: parking.id } }" v-model="parking.misc.menu.activity">
            <v-list-tile-action>
              <v-icon>mdi-settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('private_menu_parkings_activity') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile :to="{ name: 'ParkingTenant', params: { id: parking.id } }" v-model="parking.misc.menu.tenants">
            <v-list-tile-action>
              <v-icon>mdi-account-multiple-outline</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('private_menu_tenants') }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list-group>

        <v-list-tile
          :to="{ name: 'ParkingAvailability', params: { id: parking.id } }"
          v-model="parking.misc.menu.group"
          v-if="!parking.fullControl"
          :key="parking.id"
          active-class="primary--text"
          :class="`border-${parking.misc.statusColor} dps-nav-title-solo`"
          v-on:click="subToggle(parking.id)"
        >
          <v-list-tile-action>
            <v-icon>mdi-parking</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ parking.name }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
    <v-toolbar flat id="navbarBottom" height="64px">
      <v-layout justify-center align-center wrap>
        <v-spacer></v-spacer>
        <navigation-sidebar-bottom-help></navigation-sidebar-bottom-help>
        <v-spacer></v-spacer>
        <navigation-sidebar-bottom-contact></navigation-sidebar-bottom-contact>
        <v-spacer></v-spacer>
      </v-layout>
    </v-toolbar>
  </div>
</template>

<script>
import store from '@/store';
import managerService from '@/services/managerService';
import NavigationSidebarBottomContact from '@/components/commons/NavigationSidebarBottomContact.vue';
import NavigationSidebarBottomHelp from '@/components/commons/NavigationSidebarBottomHelp.vue';
import utilService from '@/services/utilService';
import _ from 'lodash';

export default {
  name: 'navigation-sidebar',
  components: {
    [NavigationSidebarBottomContact.name]: NavigationSidebarBottomContact,
    [NavigationSidebarBottomHelp.name]: NavigationSidebarBottomHelp
  },
  computed: {
    showInvoices() {
      return utilService.showInvoices();
    }
  },
  props: ['isCollapse'],
  data() {
    return {
      user: store.state.user,
      homeactive: null,
      homeVisible: true,
      parkings: [],
      listMenuParking: [],
      parkingSections: [
        {
          key: 'stats',
          routeName: 'ParkingHome'
        },
        {
          key: 'availabilities',
          routeName: 'ParkingAvailability'
        },
        {
          key: 'info',
          routeName: 'ParkingInformation'
        },
        {
          key: 'invoice',
          routeName: 'ParkingInvoices'
        },
        {
          key: 'subscriptions',
          routeName: 'ParkingSubscriptions'
        },
        {
          key: 'activity',
          routeName: 'ParkingActivity'
        },
        {
          key: 'tenants',
          routeName: 'ParkingTenant'
        },
        {
          key: 'reports',
          routeName: 'ParkingReports'
        }
      ]
    };
  },
  created() {
    managerService.parkings(this.parkingsSuccessCallback, this.parkingsErrorCallback);
  },
  methods: {
    subToggle(id) {
      for (let i = 0; i < this.parkings.length; i++) {
        if (this.parkings[i].id !== id) {
          this.parkings[i].misc.menu.group = false;
        }
      }
    },
    parkingsSuccessCallback(data) {
      // this.parkings.push(data[0]);
      if (data.length === 1) {
        this.homeVisible = false;
      } else {
        this.homeVisible = true;
      }
      let parkingsStore = [];
      _.chain(data)
        .sortBy(itParking => itParking.name)
        .each(itParking => {
          let statusColor = '';
          let statusIcon = '';

          if (!itParking.isOnline) {
            statusColor = 'red';
            statusIcon = 'mdi-wifi-off';
          } else {
            switch (itParking.status) {
              case 'ACTIVED':
                statusColor = 'green';
                statusIcon = 'mdi-wifi';
                break;
              case 'COMING_SOON':
              case 'BUILDING':
              case 'TRAINING':
                statusColor = 'yellow';
                statusIcon = 'mdi-wifi';
                break;
              case 'MAINTENANCE':
                statusColor = 'yellow';
                statusIcon = 'mdi-wifi';
                break;
              case 'OFFLINE':
                statusColor = 'red';
                statusIcon = 'mdi-wifi-off';
                break;
              case 'REMOVED':
                statusColor = 'yellow';
                statusIcon = 'mdi-wifi';
                break;
              case 'BLOCKED':
                statusColor = 'yellow';
                statusIcon = 'mdi-wifi';
                break;
              default:
                statusColor = '';
                statusIcon = 'mdi-wifi';
            }
          }

          let isGroupOpen = false;
          let currentRoute = this.$router.currentRoute;

          if (currentRoute.path.indexOf('/parking/') === 0) {
            isGroupOpen = itParking.id === Number(currentRoute.params.id);
          }

          itParking.misc = {
            statusColor: statusColor,
            statusIcon: statusIcon,
            menu: { group: isGroupOpen }
          };

          _.each(this.parkingSections, itSection => {
            itParking.misc.menu[itSection.key] = false;
          });

          this.parkings.push(_.cloneDeep(itParking));
          parkingsStore.push(itParking);
        })
        .value();

      store.commit('UPDATE_PARKING_LIST', parkingsStore);
      if (parkingsStore.length === 1) {
        this.parkings[0].misc.menu.group = true;
        if (parkingsStore[0].fullControl) {
          this.$router.push({ path: '/parking/' + parkingsStore[0].id + '/stats' });
        } else {
          this.$router.push({ path: '/parking/' + parkingsStore[0].id + '/availabilities' });
        }
      }
    },
    parkingsErrorCallback(data) {}
  }
};
</script>

<style lang="scss">
.navigation-drawer {
  z-index: 200;
  height: 100%;
}

#navbarList {
  overflow: auto;
  height: calc(100% - 128px);
}

#navbarList .el-submenu__title {
  background: #fafafa;
}

#navbarList .v-list__tile__action {
  min-width: 36px !important;
}
#navbarList .v-list__group__header__prepend-icon {
  min-width: 36px !important;
  padding: 0 9px 0 16px !important;
}

#navbarList .v-list__group__header .v-list__tile {
  padding: 0 !important;
}

#navbarList .dps-nav-title .v-list__tile__action {
  margin-left: 9px !important;
  min-width: 36px !important;
}

#navbarList .v-list__group__header--active .v-list__tile {
  color: #00bcd4 !important;
}
</style>

<style lang="scss" scoped>
.border-green {
  border-right-color: green;
  border-right-width: 5px;
  border-right-style: solid;
}

.border-red {
  border-right-color: red;
  border-right-width: 5px;
  border-right-style: solid;
}

.border-yellow {
  border-right-color: yellow;
  border-right-width: 5px;
  border-right-style: solid;
}

#logo {
  height: 40px;
  margin-top: 9px;
}
</style>



// WEBPACK FOOTER //
// src/components/commons/NavigationSidebar.vue